import { render } from "./PostForm.vue?vue&type=template&id=547bc3c4&scoped=true"
import script from "./PostForm.vue?vue&type=script&lang=js"
export * from "./PostForm.vue?vue&type=script&lang=js"

import "./PostForm.vue?vue&type=style&index=0&id=547bc3c4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Ulbi\\BlogApp\\blog_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547bc3c4"]])

export default __exports__